import React, { useEffect, useState, forwardRef } from 'react';
import {
    AppBar,
    Box,
    Button,
    Dialog,
    DialogContent,
    Divider,
    IconButton,
    Slide,
    Toolbar,
    Typography,
    useTheme,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import Row from '../../../Common/Row';
import Space from '../../../Common/Space';

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function FilterOverlayMobile({open,
    onClose,
    filter,        // { key, label, options: [{ label, value }] }
    params = [],   // current selected values from URL
    onSave,
}) {
    const theme = useTheme();
    const [selectedValues, setSelectedValues] = useState(params);
    const hasSelection = selectedValues.length > 0;

    useEffect(() => {
        if (open) setSelectedValues(params);
    }, [params, open]);

    const handleToggle = (value) =>
        setSelectedValues((prev) =>
            prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value],
        );

    const handleReset = () => setSelectedValues([]);
    const handleSave = () => {
        onSave(selectedValues);
        onClose();
    };

    return (
        <Dialog
            fullScreen
            TransitionComponent={Transition}
            open={open}
            onClose={onClose}
            PaperProps={{ sx: { display: 'flex', flexDirection: 'column' } }}
        >
            {/* Top bar */}
            <AppBar elevation={0} color="transparent" position="relative">
                <Toolbar sx={{ px: 2 }}>
                    <Typography variant="h6" sx={{ flex: 1, fontWeight: 'bold' }}>
                        {filter.label}
                    </Typography>

                    <Typography
                        sx={{
                            mr: 3,
                            visibility: hasSelection ? 'visible' : 'hidden',
                            fontWeight: 'bold',
                            color: theme.palette.jagtred.main,
                            cursor: hasSelection ? 'pointer' : 'default',
                        }}
                        onClick={hasSelection ? handleReset : undefined}
                    >
                        Nulstil
                    </Typography>

                    <IconButton edge="end" onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>

            {/* Options list */}
            <DialogContent sx={{ p: 0, flex: 1, overflowY: 'auto' }}>
                {filter.options.map((option, idx) => (
                    <React.Fragment key={option.value}>
                        {idx !== 0 && <Divider />}
                        <Box
                            sx={{
                                px: 3,
                                py: 2,
                                fontWeight: selectedValues.includes(option.value) ? 'bold' : 'normal',
                                cursor: 'pointer',
                            }}
                            onClick={() => handleToggle(option.value)}
                        >
                            <Row sx={{ justifyContent: 'space-between' }}>
                                {option.label}
                                {selectedValues.includes(option.value) && (
                                    <CheckIcon fontSize="small" sx={{ color: theme.palette.jagtred.main }} />
                                )}
                            </Row>
                        </Box>
                    </React.Fragment>
                ))}
            </DialogContent>

            {/* Bottom save button */}
            <Box
                sx={{
                    p: 2,
                    borderTop: '1px solid',
                    borderColor: 'divider',
                }}
            >
                <Button fullWidth variant="contained" color="jagtred" size="large" onClick={handleSave}>
                    Gem
                </Button>
            </Box>
        </Dialog>
    );
}
